import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const exportToExcel = (jsonData, originalFilename="Import_Booking") => {
  const { existedBooking, invalidBooking, invalidProfile, duplicatedTickets } = jsonData.data;

  const workbook = XLSX.utils.book_new();

  // Helper to convert string arrays to object arrays
  const normalizeArray = (arr, keyName) => {
    if (!Array.isArray(arr)) return [];
    return arr.map((item) => (typeof item === "object" ? item : { [keyName]: item }));
  };

  // Add sheet if data is present
 const addTableSheet = (dataArray, sheetName, keyNameIfPrimitive = null) => {
    const data = keyNameIfPrimitive
      ? normalizeArray(dataArray, keyNameIfPrimitive)
      : dataArray;

    if (!data || data.length === 0) return;

    const ws = XLSX.utils.json_to_sheet(data, { origin: "A1" });

    // Define the range of the table
    const range = XLSX.utils.decode_range(ws["!ref"]);
    const cols = Object.keys(data[0]);

    // Add header styling by marking it as a table
    ws["!autofilter"] = { ref: XLSX.utils.encode_range(range) };

    // Optionally set column widths
    ws["!cols"] = cols.map(() => ({ wch: 20 }));

    XLSX.utils.book_append_sheet(workbook, ws, sheetName);
  };

  addTableSheet(existedBooking, "Existed Booking");
  addTableSheet(invalidBooking, "Invalid Booking");
  addTableSheet(invalidProfile, "Invalid Profile", "Invalid Entry");
  addTableSheet(duplicatedTickets, "Duplicated Tickets");

  const baseName = originalFilename.replace(/\.[^/.]+$/, "");

  const fileName = `${baseName}_Error.xlsx`;
  const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);
};


export default exportToExcel;